module.exports = __webpack_public_path__ + "static/media/elixir-signages.0e96f2a6.pdf";